export default __webpack_public_path__ + "static/bentoImg4-df0641f27649bc84170a8fff76853d2f.webp";